@if (visible()) {
  <span class="badge bg-body-secondary option-status-badge" role="group">
    <i
      class="fas"
      [class.fa-lock]="session.restrictionsActive()"
      [class.fa-lock-open]="!session.restrictionsActive()"
      [class.text-success]="session.restrictionsActive()"
      [class.text-secondary]="!session.restrictionsActive()"
      [title]="
        ('data-restrictions' | translate) +
        ': ' +
        ((session.restrictionsActive() ? 'enabled' : 'disabled') | translate)
      "
      [attr.aria-label]="
        ('data-restrictions' | translate) +
        ': ' +
        ((session.restrictionsActive() ? 'enabled' : 'disabled') | translate)
      "
      role="img"
    ></i>
    <i
      class="fa-solid fa-circle-exclamation"
      [class.text-success]="session.suspicionActive()"
      [class.text-secondary]="!session.suspicionActive()"
      [title]="
        ('suspicions' | translate) +
        ': ' +
        ((session.suspicionActive() ? 'enabled' : 'disabled') | translate)
      "
      [attr.aria-label]="
        ('suspicions' | translate) +
        ': ' +
        ((session.suspicionActive() ? 'enabled' : 'disabled') | translate)
      "
      role="img"
    ></i>
    <i
      class="fa-solid fa-shield-halved"
      [class.text-success]="session.dataProtectionActive()"
      [class.text-secondary]="!session.dataProtectionActive()"
      [title]="
        ('data-protection' | translate) +
        ': ' +
        ((session.dataProtectionActive() ? 'enabled' : 'disabled') | translate)
      "
      [attr.aria-label]="
        ('data-protection' | translate) +
        ': ' +
        ((session.dataProtectionActive() ? 'enabled' : 'disabled') | translate)
      "
      role="img"
    ></i>
  </span>
}
